<template>
  <a
      :class="[{'associated-documents-item': !isBtn}, document.code]"
      :href="documentLink(document)"
      :target="document.link && !document.forceLinkDownload ? '_blank' : '_self'"
      :data-tracking="`machine_sheet__link__${ (document.documentsAttribute ? document.documentsAttribute : document.identifier) }`"
      @click="downloadDocument(document)"
      class="document-item"
  >
    <template v-if="isBtn">
      <slot></slot>
    </template>
    <template v-else>
      <div class="top-part" v-if="document.extension">
        <span class="icon-file-pdf" :class="brandColor" v-if="document.extension === 'pdf'"></span>
        <span class="icon-file-doc" :class="brandColor" v-else-if="['doc', 'docx'].includes(document.extension)"></span>
        <span class="icon-file-xls" :class="brandColor" v-else-if="['xls', 'xlsx'].includes(document.extension)"></span>
        <span class="icon-file-ppt" :class="brandColor" v-else-if="['ppt', 'pptx'].includes(document.extension)"></span>
        <span class="icon-file" :class="brandColor" v-else></span>
      </div>
      <div class="bottom-part">
        <div class="details">
          <h4 class="document-title" :title="document.name" >{{document.name}}</h4>
         <div class="download-button">
           <span class="icon-download" :class="brandColor"></span>
         </div>
        </div>
      </div>
    </template>
  </a>
</template>

<script>
import axios from 'axios'
import {saveAs} from 'file-saver';

export default {
  name: 'AssociatedDocumentsItem',
  computed: {
    documentName() {
      if (this.document.name.length >35)
        return this.document.name.substr(0,35)+"..."
      return this.document.name.substr(0,35)
    }
  },
  props: {
    document: {
      type: Object,
      default: null
    },
    isBtn: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    documentLink(document) {
      if (document.link && !document.forceLinkDownload)
        return document.link
      else
        return 'javascript:;'
    },
    async downloadDocument(document) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      const isIos = (!!userAgent.match(/iphone/i) || !!userAgent.match(/ipad/i));
      if (document.link) {
        if (document.forceLinkDownload) {
          if (isIos) {
            window.open(document.link)
          } else {
            this.startLoading(this.$t('download_in_progress_please_wait'));
            axios({
              url: document.link,
              method: 'GET',
              responseType: 'blob',
            })
                .then((response) => {
                  const blob = new Blob([response.data]);
                  saveAs(blob, document.filename)
                })
                .finally(() => this.stopLoading());
          }
        }
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.associated-documents-item {
  position: relative;
  flex: 0 0 calc((100% / 6) - 20px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10px;
  height: 230px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 20px 20px 74px 0 rgba(0, 0, 0, 0.15);
  background-color: $white;
  border: solid 2px $white;
  transition: border-color 0.3s ease;

  @media #{$mq_large_desktop} {
    flex: 0 0 calc((100% / 5) - 20px);
  }

  @media #{$mq_small_desktop} {
    flex: 0 0 calc((100% / 4) - 20px);
  }

  @media #{$mq_tablet} {
    flex: 0 0 calc((100% / 3) - 20px);
  }

  @media #{$mq_phone} {
    flex: 0 0 100%;
    margin: 0 0 20px 0;
  }

  @each $brand in $brands {
    .brand-#{$brand} & {
      &:hover {
        border: solid 2px brand-color($brand);
      }
    }
  }

  .top-part {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40%;
    width: 100%;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;

    [class^="icon-"], [class*=" icon-"] {
      display: block;
      font-size: 60px;
    }
  }

  .bottom-part {
    position: relative;
    flex: 1 1 auto;
    height: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    padding-bottom:30px;

    .details {
      .document-title {
        font-size: 18px;
        font-weight: 900;
        line-height: 1;
        margin-bottom: 10px;
        padding: 0 20px;
       // height: 80px;
        display: flex;
        align-items: center;

      }

      .download-button {
        position:absolute;
        bottom:15px;
        text-align:center;
        width:100%;
        left:0;
      }

      [class^="icon-"], [class*=" icon-"] {
        display: block;
        font-size: 30px;
      }
    }
  }
}
</style>
